import React, {Component} from 'react';
import moment from 'moment';
import {Button, Loader} from 'semantic-ui-react';
import {yearFormat, monthFormat} from '../../constants/datesFormat';
import {getMonthShortName, getLastDayOfMonth} from '../../util/date';
import './dateFiltersSection.scss';

const currentYear = parseInt(moment().format(yearFormat), 10);
const currentMonth = parseInt(moment().format(monthFormat), 10);

class FiltersSectionMultiple extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'yearSelected': currentYear,
      'monthSelected': currentMonth,
      'initialMonthSelected': currentMonth,
      'finalMonthSelected': currentMonth,
      'initialDaySelected': '',
      'finalDaySelected': '',
    };
  }

  componentDidMount() {
    this.getDateFilters();
  }

  componentDidUpdate() {
    const {clearFilters} = this.props;
    const {yearSelected, initialMonthSelected} = this.state;

    if (clearFilters.year && yearSelected) {
      this.onUpdateYearClick('');
      return;
    }
    if (clearFilters.month && initialMonthSelected) {
      this.onUpdateMonthRangeClick('');
      return;
    }
    if (!clearFilters.day) {
      return;
    }
    this.onUpdateDayClick('CLEAR');
    this.onUpdateMonthRangeClick('CLEAR');
  }

  // eslint-disable-next-line max-statements
  getRangeDate = () => {
    const {yearSelected, initialDaySelected, finalDaySelected, initialMonthSelected, finalMonthSelected} = this.state;
    
    const initMonth = this.formatNumber(initialMonthSelected);
    const finalMonth = this.formatNumber(finalMonthSelected);
    const initialDay = this.formatNumber(initialDaySelected);
    const finalDay = this.formatNumber(finalDaySelected);
    const lastDay = getLastDayOfMonth(yearSelected, finalMonthSelected);
    const validateFinalDay = finalDay > lastDay ? lastDay : finalDay;
    
    if (!yearSelected && !initialMonthSelected && !finalMonthSelected &&
      !initialDaySelected && !finalDaySelected) {
      return {
        'startDate': null,
        'endDate': null,
      };
    }
    if (!initialMonthSelected && !finalMonthSelected && !initialDaySelected && !finalDaySelected) {
      return {
        'startDate': `${yearSelected}-01-01`,
        'endDate': `${yearSelected}-12-31`,
      };
    }
    if (!initialDaySelected && !finalDaySelected && (initialMonthSelected || finalMonthSelected)) {
      const lastDay = getLastDayOfMonth(yearSelected, finalMonthSelected);
      return {
        'startDate': `${yearSelected}-${initMonth}-01`,
        'endDate': `${yearSelected}-${finalMonth}-${lastDay}`,
      };
    }
    if (!finalDaySelected) {
      return {
        'startDate': `${yearSelected}-${initMonth}-${initialDay}`,
        'endDate': `${yearSelected}-${finalMonth}-${initialDay}`,
      };
    }
    return {
      'startDate': `${yearSelected}-${initMonth}-${initialDay}`,
      'endDate': `${yearSelected}-${finalMonth}-${validateFinalDay}`,
    };
  }

  getDateFilters = () => {
    const {yearSelected, initialDaySelected, finalDaySelected,
      initialMonthSelected, finalMonthSelected} = this.state;
    const rangeDate = this.getRangeDate();
    const queryString = {
      'startDate': rangeDate.startDate,
      'endDate': rangeDate.endDate,
      'year': yearSelected,
      'initialDay': initialDaySelected,
      'finalDay': finalDaySelected,
      'initialMonth': initialMonthSelected,
      'endMonth': finalMonthSelected,

    };
    this.props.onDateFiltersClick(queryString);
  }

  formatNumber = (number) => {
    if (number < 10) {
      return `0${number}`;
    }
    return number;
  }

  onUpdateDayClick = (day) => {
    const {initialDaySelected, finalDaySelected} = this.state;
    if (day === 'CLEAR') {
      this.setState({
        'initialDaySelected': '',
        'finalDaySelected': '',
      }, () => this.getDateFilters());
      return;
    }
    if ((!initialDaySelected && !finalDaySelected) ||
      (initialDaySelected && finalDaySelected && day < initialDaySelected)) {
      this.setState({'initialDaySelected': day}, () => this.getDateFilters());
      return;
    }
    if (!finalDaySelected && day < initialDaySelected) {
      this.setState({
        'initialDaySelected': day,
        'finalDaySelected': initialDaySelected,
      }, () => this.getDateFilters());
      return;
    }
    this.setState({'finalDaySelected': day}, () => this.getDateFilters());
  }

  // eslint-disable-next-line max-statements
  onUpdateMonthRangeClick = (month) => {
    const {initialMonthSelected, finalMonthSelected} = this.state;

    if (month === 'CLEAR') {
      this.setState({
        'initialMonthSelected': +moment().format('M'),
        'finalMonthSelected': +moment().format('M'),
      }, () => this.getDateFilters());
      return;
    }

    if (!finalMonthSelected && !initialMonthSelected) {
      this.setState({
        'initialMonthSelected': month,
        'finalMonthSelected': month,
      });
    }

    if (initialMonthSelected && finalMonthSelected && month < initialMonthSelected) {
      this.setState({'initialMonthSelected': month}, () => this.getDateFilters());
      return;
    }

    if (!finalMonthSelected && month <= initialMonthSelected) {
      this.setState({
        'initialMonthSelected': month,
        'finalMonthSelected': finalMonthSelected,
      }, () => this.getDateFilters());
      return;
    }

    if (finalMonthSelected === month) {
      this.setState({
        'initialMonthSelected': month,
      }, () => this.getDateFilters());
      return;
    }

    this.setState({
      'finalMonthSelected': month,
    }, () => this.getDateFilters());
  }

  onUpdateYearClick = (year) => {
    const newState = {'yearSelected': year};
    if (!year) {
      newState.monthSelected = '';
      newState.initialDaySelected = '';
      newState.finalDaySelected = '';
      this.setState(newState, () => this.getDateFilters());
      return;
    }

    const {monthSelected, initialDaySelected, finalDaySelected} = this.state;
    const lastDayOfMonth = year && monthSelected && (initialDaySelected || finalDaySelected) ?
      getLastDayOfMonth(year, monthSelected) : '';
    if (monthSelected && finalDaySelected && finalDaySelected > lastDayOfMonth) {
      newState.finalDaySelected = lastDayOfMonth;
    }
    if (monthSelected && initialDaySelected && initialDaySelected > lastDayOfMonth) {
      newState.initialDaySelected = lastDayOfMonth;
    }
    this.setState(newState, () => this.getDateFilters());
  }

  getYears = () => {
    const {years, loadingYears} = this.props;
    const {yearSelected} = this.state;

    if (loadingYears) {
      return <Loader active inline='centered' />;
    }
    return years.map((element, index) => {
      const isPrimaryButton = element.year === yearSelected;
      return (
        <Button
          key={index}
          type='button'
          primary={isPrimaryButton}
          secondary={!isPrimaryButton}
          disabled={loadingYears}
          loading={loadingYears}
          onClick={ () => this.onUpdateYearClick(element.year)}
        >
          {element.year}
        </Button>
      );
    });
  }

  getMonths = () => {
    const {yearSelected, initialMonthSelected, finalMonthSelected} = this.state;
    const months = [];
    for (let i = 1; i <= 12; i ++) {
      months.push(i);
    }

    return months.map((month, index) => {
      const isPrimaryButton = month === initialMonthSelected || month === finalMonthSelected ||
      (month > initialMonthSelected && month < finalMonthSelected);
      return (
        <Button
          key={index}
          type='button'
          primary={isPrimaryButton}
          secondary={!isPrimaryButton}
          disabled={!yearSelected}
          onClick={this.onUpdateMonthRangeClick.bind(this, month)}
        >
          {getMonthShortName(month)}
        </Button>
      );
    });
  }

  getDays = () => {
    const {showDays} = this.props;
    if (!showDays) {
      return null;
    }
    
    const {yearSelected, finalMonthSelected, initialDaySelected, finalDaySelected} = this.state;
    const lastDayOfMonth = yearSelected && finalMonthSelected ? getLastDayOfMonth(yearSelected, finalMonthSelected) : 0;
    const days = [];
    for (let i = 1; i <= 31; i ++) {
      days.push(i);
    }
    return days.map((day, index) => {
      const isPrimaryButton = day === initialDaySelected || day === finalDaySelected ||
        (day > initialDaySelected && day < finalDaySelected);
      return (
        <Button
          key={index}
          type='button'
          primary={isPrimaryButton}
          secondary={!isPrimaryButton}
          className='toyota-primary'
          disabled={!yearSelected || !finalMonthSelected || day > lastDayOfMonth}
          onClick={() => this.onUpdateDayClick(day)}
        >
          {day}
        </Button>
      );
    });
  }

  render() {
    return (
      <div className='filters-container'>
        <div>
          <span className='years-container'>
            {this.getYears()}
          </span>
          {this.getMonths()}
        </div>
        <div className='days-container'>
          {this.getDays()}
        </div>
      </div>
    );
  }
}

export default FiltersSectionMultiple;
